import { render } from "./PannDettInterventiInCorsoRiga.vue?vue&type=template&id=6e2b2284"
import script from "./PannDettInterventiInCorsoRiga.vue?vue&type=script&lang=js"
export * from "./PannDettInterventiInCorsoRiga.vue?vue&type=script&lang=js"

import "./PannDettInterventiInCorsoRiga.vue?vue&type=style&index=0&id=6e2b2284&lang=css"

import exportComponent from "C:\\Ecommerce\\CONAD_MANUTENZIONI\\conad-manutenzioni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__